/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrackingGroupShipment } from './TrackingGroupShipment';
import {
    TrackingGroupShipmentFromJSON,
    TrackingGroupShipmentFromJSONTyped,
    TrackingGroupShipmentToJSON,
    TrackingGroupShipmentToJSONTyped,
} from './TrackingGroupShipment';

/**
 * 
 * @export
 * @interface TrackingGroup
 */
export interface TrackingGroup {
    /**
     * 
     * @type {Array<TrackingGroupShipment>}
     * @memberof TrackingGroup
     */
    shipments: Array<TrackingGroupShipment>;
}

/**
 * Check if a given object implements the TrackingGroup interface.
 */
export function instanceOfTrackingGroup(value: object): value is TrackingGroup {
    if (!('shipments' in value) || value['shipments'] === undefined) return false;
    return true;
}

export function TrackingGroupFromJSON(json: any): TrackingGroup {
    return TrackingGroupFromJSONTyped(json, false);
}

export function TrackingGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'shipments': ((json['shipments'] as Array<any>).map(TrackingGroupShipmentFromJSON)),
    };
}

  export function TrackingGroupToJSON(json: any): TrackingGroup {
      return TrackingGroupToJSONTyped(json, false);
  }

  export function TrackingGroupToJSONTyped(value?: TrackingGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipments': ((value['shipments'] as Array<any>).map(TrackingGroupShipmentToJSON)),
    };
}

